<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form">
    <mat-dialog-content>
        <mat-tab-group animationDuration="1000ms">
            <mat-tab label="Datos Generales">
                <div class="container-fluid mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-4 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Clave Interna</mat-label>
                                <input matInput formControlName="claveInterna" placeholder="Clave Interna"
                                    (blur)="form.controls['claveInterna'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="10">
                                <mat-error *ngIf="isValidField('claveInterna')">
                                    {{ getFieldError('claveInterna') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">

                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Equipo</mat-label>
                                <input type="text" matInput [formControl]="codigoEquipoControl"
                                    [matAutocomplete]="autoEquipo" placeholder="Escribe para buscar..."
                                    (focus)="abrirAutocompleteCodigoEquipo()"
                                    (blur)="codigoEquipoControl.markAsTouched()" uppercase />
                                <mat-autocomplete #autoEquipo="matAutocomplete"
                                    (optionSelected)="seleccionarCodigoEquipo($event)">
                                    <mat-option *ngFor="let codigoEquipo of filteredCodigoEquipos$ | async"
                                        [value]="codigoEquipo">
                                        {{ codigoEquipo.claveEquipo }} - {{ codigoEquipo.nombreEquipo }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                <mat-error *ngIf="codigoEquipoControl.invalid && codigoEquipoControl.touched">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Modelo</mat-label>
                                <input matInput formControlName="modelo" placeholder="Modelo"
                                    (blur)="form.controls['modelo'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="50">
                                <mat-error *ngIf="isValidField('modelo')">
                                    {{ getFieldError('modelo') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Serie</mat-label>
                                <input matInput formControlName="serie" placeholder="Serie"
                                    (blur)="form.controls['serie'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="50">
                                <mat-error *ngIf="isValidField('serie')">
                                    {{ getFieldError('serie') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-4 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Departamento</mat-label>
                                <input type="text" matInput [formControl]="departamentoControl"
                                    [matAutocomplete]="autoDepartamento" placeholder="Escribe para buscar..."
                                    (focus)="abrirAutocompleteDepartamento()"
                                    (blur)="departamentoControl.markAsTouched()" uppercase />
                                <mat-autocomplete #autoDepartamento="matAutocomplete"
                                    (optionSelected)="seleccionarDepartamento($event)">
                                    <mat-option *ngFor="let departamento of filteredDepartamento$ | async"
                                        [value]="departamento">
                                        {{ departamento.nombreArea }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                <mat-error *ngIf="departamentoControl.invalid && departamentoControl.touched">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Responsable</mat-label>
                                <input type="text" matInput [formControl]="colaboradorControl"
                                    [matAutocomplete]="autoColaborador" placeholder="Escribe para buscar..."
                                    (focus)="abrirAutocomplete()" (blur)="colaboradorControl.markAsTouched()"
                                    uppercase />
                                <mat-autocomplete #autoColaborador="matAutocomplete"
                                    (optionSelected)="seleccionarColaborador($event)">
                                    <mat-option *ngFor="let colaborador of filteredColaboradores$ | async"
                                        [value]="colaborador">
                                        {{ colaborador.idColaborador }} - {{ colaborador.nombre }} {{
                                        colaborador.apellidoPaterno }}
                                        {{ colaborador.apellidoMaterno }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                <mat-error *ngIf="colaboradorControl.invalid && colaboradorControl.touched">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-4 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Localización</mat-label>
                                <input matInput formControlName="localizacion" placeholder="Localización"
                                    (blur)="form.controls['localizacion'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="70">
                                <mat-error *ngIf="isValidField('localizacion')">
                                    {{ getFieldError('localizacion') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Marca</mat-label>
                                <input type="text" matInput [formControl]="marcaControl" [matAutocomplete]="autoMarca"
                                    placeholder="Escribe para buscar..." (focus)="abrirAutocompleteMarca()"
                                    (blur)="marcaControl.markAsTouched()" uppercase />
                                <mat-autocomplete #autoMarca="matAutocomplete"
                                    (optionSelected)="seleccionarMarca($event)">
                                    <mat-option *ngFor="let marca of filteredMarca$ | async" [value]="marca">
                                        {{ marca.marca }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                <mat-error *ngIf="marcaControl.invalid && marcaControl.touched">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-2">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>¿Equipo o Patrón?</mat-label>
                                <mat-select formControlName="ep" (blur)="form.controls['ep'].markAsTouched()" required>
                                    <mat-option value="EP">EP</mat-option>
                                    <mat-option value="PATRÓN">PATRÓN</mat-option>
                                </mat-select>
                                <mat-error *ngIf="isValidField('ep')">
                                    {{ getFieldError('ep') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-1 col-md-2">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Sig. Calibración</mat-label>
                                <input matInput placeholder="Sig. Calibración" maxlength="10"
                                    formControlName="fechaCalibracion">

                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-1 col-md-2">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Semana</mat-label>
                                <input matInput placeholder="Semana" maxlength="10" formControlName="numeroSemana">

                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-2">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Calibración</mat-label>
                                <input matInput formControlName="tipCalib" placeholder="Calibración"
                                    (blur)="form.controls['tipCalib'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="10">
                                <mat-error *ngIf="isValidField('tipCalib')">
                                    {{ getFieldError('tipCalib') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Estatus</mat-label>
                                <mat-select formControlName="activo" (blur)="form.controls['activo'].markAsTouched()"
                                    required>
                                    <mat-option [value]="true">ACTIVO</mat-option>
                                    <mat-option [value]="false">FUERA DE SERVICIO</mat-option>
                                </mat-select>
                                <mat-error *ngIf="isValidField('activo')">
                                    {{ getFieldError('activo') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Fecha Alta</mat-label>
                                <input matInput [matDatepicker]="fechaAlta" formControlName="fechaAlta">
                                <mat-datepicker-toggle matSuffix [for]="fechaAlta"></mat-datepicker-toggle>
                                <mat-datepicker #fechaAlta></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Fecha Baja</mat-label>
                                <input matInput [matDatepicker]="fechaBaja" formControlName="fechaBaja">
                                <mat-datepicker-toggle matSuffix [for]="fechaBaja"></mat-datepicker-toggle>
                                <mat-datepicker #fechaBaja></mat-datepicker>
                            </mat-form-field>
                        </div>


                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Notas</mat-label>
                                <textarea matInput formControlName="condAlmacenamiento" placeholder="Notas"
                                    (blur)="form.controls['condAlmacenamiento'].markAsTouched()" uppercase
                                    maxlength="250"></textarea>
                                <mat-error *ngIf="isValidField('condAlmacenamiento')">
                                    {{ getFieldError('condAlmacenamiento') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Datos de Calibración">
                <div class="container-fluid mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-3 col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Tipo de Variable</mat-label>
                                <mat-select formControlName="tipoVariable"
                                    (blur)="form.controls['tipoVariable'].markAsTouched()">
                                    <mat-option value="CONTROL">CONTROL</mat-option>
                                    <mat-option value="CRITICA">CRITICA</mat-option>
                                    <mat-option value="REFERENCIA">REFERENCIA</mat-option>
                                </mat-select>
                                <mat-error *ngIf="isValidField('tipoVariable')">
                                    {{ getFieldError('tipoVariable') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Unidades</mat-label>
                                <input type="text" matInput [formControl]="unidadControl" [matAutocomplete]="autoUnidad"
                                    placeholder="Escribe para buscar..." (focus)="abrirAutocompleteUnidad()"
                                    (blur)="unidadControl.markAsTouched()" uppercase />
                                <mat-autocomplete #autoUnidad="matAutocomplete"
                                    (optionSelected)="seleccionarUnidad($event)">
                                    <mat-option *ngFor="let unidad of filteredUnidad$ | async" [value]="unidad">
                                        {{ unidad.nombreUnidad }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                <mat-error *ngIf="unidadControl.invalid && unidadControl.touched">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Calibración</mat-label>
                                <mat-select formControlName="tipCalib"
                                    (blur)="form.controls['tipCalib'].markAsTouched()">
                                    <mat-option value="INTERNA">INTERNA</mat-option>
                                    <mat-option value="EXTERNA">EXTERNA</mat-option>
                                </mat-select>
                                <mat-error *ngIf="isValidField('tipCalib')">
                                    {{ getFieldError('tipCalib') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Lugar de Calibración</mat-label>
                                <input matInput formControlName="lugarCalibracion" placeholder="Lugar de Calibración"
                                    (blur)="form.controls['lugarCalibracion'].markAsTouched()" uppercase
                                    alphanumericOnly maxlength="70">
                                <mat-error *ngIf="isValidField('lugarCalibracion')">
                                    {{ getFieldError('lugarCalibracion') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-3 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Legibilidad/Resolución</mat-label>
                                <input matInput formControlName="resolucion" placeholder="Legibilidad/Resolución"
                                    (blur)="form.controls['resolucion'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="35">
                                <mat-error *ngIf="isValidField('resolucion')">
                                    {{ getFieldError('resolucion') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Exactitud del Equipo</mat-label>
                                <input matInput formControlName="exactitud" placeholder="Exactitud del Equipo"
                                    (blur)="form.controls['exactitud'].markAsTouched()" uppercase alphanumericOnly
                                    maxlength="35">
                                <mat-error *ngIf="isValidField('exactitud')">
                                    {{ getFieldError('exactitud') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Incetidumbre Requerida</mat-label>
                                <input matInput formControlName="criterioAceptacion"
                                    placeholder="Incetidumbre Requerida"
                                    (blur)="form.controls['criterioAceptacion'].markAsTouched()" numbersDecimal
                                    maxlength="35">
                                <mat-error *ngIf="isValidField('criterioAceptacion')">
                                    {{ getFieldError('criterioAceptacion') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-3 col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Alcance</mat-label>
                                <input matInput formControlName="interOperacion" placeholder="Alcance"
                                    (blur)="form.controls['interOperacion'].markAsTouched()" uppercase maxlength="35">
                                <mat-error *ngIf="isValidField('interOperacion')">
                                    {{ getFieldError('interOperacion') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-3 col-md-4">
                            <button type="button" mat-raised-button color="primary"
                                class="ml-2 px-3 d-flex align-items-center justify-content-center btn-equal-height"
                                (click)="modal()">Alcance</button>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4"></div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Análisis de medición">
                <div class="container mt-4">
                    <!-- Título de la tabla -->
                    <div class="row font-weight-bold">
                        <div class="col-md-6">Descripción</div>
                        <div class="col-md-3 text-center">Frecuencia (sem.)</div>
                        <div class="col-md-3 text-center">Empieza a partir de</div>
                    </div>

                    <!-- Fila 1 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Calibración:</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="calibFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker1" formControlName="calibApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Fila 2 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Repetibilidad y Reproducibilidad M.
                                Largo:</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="rRLargoFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker2" formControlName="rRLargoApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>


                    <!-- Fila 3 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Repetibilidad y Reproducibilidad M.
                                Corto:</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="rRCortoFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker3" formControlName="rRCortoApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                <mat-datepicker #picker3></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Fila 4 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Repetibilidad y Reproducibilidad y
                                Varuación Parte por Parte:</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="rRVPPFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker4" formControlName="rRVPPApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                <mat-datepicker #picker4></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Fila 5 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Exactitud (Bias):</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="biasFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker5" formControlName="biasApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                <mat-datepicker #picker5></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Fila 6 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Linealidad:</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="linealidadFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker6" formControlName="linealidadApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                <mat-datepicker #picker6></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Fila 7 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Estabilidad:</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="estabilidadFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker7" formControlName="estabilidadApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
                                <mat-datepicker #picker7></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Fila 8 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Atributos (Gage Go - No Go):</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="atributosFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker8" formControlName="atributosApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
                                <mat-datepicker #picker8></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Fila 9 -->
                    <div class="row align-items-center my-2">
                        <div class="col-md-6"><label class="font-weight-bold">Repetibilidad y Reproducibilidad para
                                Gages:</label></div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput type="number" formControlName="rRGagesFrecuencia">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput [matDatepicker]="picker9" formControlName="rRGagesApartir">
                                <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
                                <mat-datepicker #picker9></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

            </mat-tab>
            <mat-tab label="Método Calibración" *ngIf="mostrarTap">
                <div class="container-fluid mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Clave</mat-label>
                                <input matInput formControlName="claveEquipo" placeholder="Clave" uppercase>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Realizo</mat-label>
                                <input type="text" matInput [formControl]="realizoControl"
                                    [matAutocomplete]="autoRealizo" placeholder="Escribe para buscar..."
                                    (focus)="abrirAutocompleteRealizo()" (blur)="realizoControl.markAsTouched()"
                                    uppercase />
                                <mat-autocomplete #autoRealizo="matAutocomplete"
                                    (optionSelected)="seleccionarRealizo($event)">
                                    <mat-option *ngFor="let colaborador of filteredRealizo$ | async"
                                        [value]="colaborador">
                                        {{ colaborador.idColaborador }} - {{ colaborador.nombre }} {{
                                        colaborador.apellidoPaterno }} {{ colaborador.apellidoMaterno }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                <mat-error *ngIf="realizoControl.invalid && realizoControl.touched">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Procedimiento</mat-label>
                                <textarea matInput formControlName="procedimiento" placeholder="Procedimiento"
                                    (blur)="form.controls['procedimiento'].markAsTouched()" uppercase
                                    maxlength="250"></textarea>
                                <mat-error *ngIf="isValidField('procedimiento')">
                                    {{ getFieldError('procedimiento') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton" (click)="enviar()">
            <mat-icon>save</mat-icon> Guardar
        </button>
        <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
            <mat-icon>close</mat-icon> Cancelar
        </button>
    </mat-dialog-actions>
</form>